import crm from './crm';

const TicketPrioridade = {
	index:()=>{
		return crm.get('/ticket-prioridade');
	},
	show:(id)=>{
		return crm.get('/ticket-prioridade/'+id);
	},
	updade: (dados, id) => {
        let uri = '/ticket-prioridade/' + id;
        return crm['put'].call(crm, uri, {prioridade: dados});
    },
	store: (dados) => {
        let uri = '/ticket-prioridade';
        return crm['post'].call(crm, uri, {prioridade: dados});
    },
};

export default TicketPrioridade;
